import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";

const videos = [
  { id: "jGTZFPFWO8w", name: "Jiří Ptáčník" },
  { id: "CJr-SZPri5c", name: "Lenka Krobotová" },
];

const LiteYouTube = ({ id, name }: { id: string; name: string }) => {
  const [activated, setActivated] = useState(false);

  if (activated) {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${id}?rel=0&autoplay=1`}
        title={`Video reference – ${name}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setActivated(true)}
      aria-label={`Video reference – ${name}`}
      className="absolute inset-0 w-full h-full group cursor-pointer"
    >
      <img
        src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
        alt={`Video reference – ${name}`}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <span className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
        <span className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/90 shadow-lg group-hover:scale-110 transition-transform">
          <Play className="h-7 w-7 text-primary-foreground fill-current ml-1" />
        </span>
      </span>
    </button>
  );
};

const TestimonialsSection = () => {
  return (
    <section id="reference" className="section-padding bg-gradient-to-b from-background to-muted/20">
      <div className="container-luxury">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-14"
        >
          <span className="badge-remax mb-6">Reference</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground">
            Co říkají klienti
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {videos.map((v, i) => (
            <motion.div
              key={v.id}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-2xl overflow-hidden border border-border/30 bg-card"
              style={{ boxShadow: 'var(--shadow-card)' }}
            >
              <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                <LiteYouTube id={v.id} name={v.name} />
              </div>
              <div className="p-4 text-center">
                <span className="font-heading font-semibold text-sm text-foreground">{v.name}</span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Link to full references page */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mt-10"
        >
          <Link
            to="/reference"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary/10 text-primary font-medium text-sm hover:bg-primary/20 transition-colors duration-300"
          >
            Zobrazit všechny reference
            <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
